import { Component, ChangeDetectionStrategy, Input, ChangeDetectorRef } from '@angular/core';
import { Question, TableHandler } from '../../../../../../classes';
import { Subscription } from 'rxjs';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'checkbox-table',
  templateUrl: './checkbox-table.component.html',
  styleUrls: ['./checkbox-table.component.css'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class CheckboxTableComponent {
  @Input() question:Question;
  @Input() questionFormGroup:FormGroup
  get table ():TableHandler {
    return this.question.table;
  }
  subscriptions:Subscription[] = [];
  constructor (
    private cdRef:ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.subscriptions.push(this.question.getChildTracker('options').onContentUpdate.subscribe(()=>this.cdRef.detectChanges()));
  }
  ngOnDestroy () {
    this.subscriptions.forEach(sub=>sub.unsubscribe());
  }
  trackByIndexFn(index:number, val) {
    return index;
  }
  trackByIdFn(index:number, val:any){
    return val.id;
  }
}
